export const DEFAULT_PAGE_SIZE = 25;

export const defaultUrlFilters = {
  lifecycle: 'open',
  assignee_id: null,
  current_status_id: null,
  due_mode: 'all',
  due_date: null,
  final_outcome_id: null,
  sort: 'created_at',
  sort_direction: 'desc',
};

export const cleanParams = (params) => (
  Object.entries(params).reduce((acc, [key, value]) => {
    if (value === null || value === undefined || value === '') return acc;
    if (Array.isArray(value) && value.length === 0) return acc;

    acc[key] = value;
    return acc;
  }, {})
);

export const filtersFromSearch = (search) => {
  const params = new URLSearchParams(search);

  return {
    ...defaultUrlFilters,
    lifecycle: params.get('lifecycle') === 'all' ? 'all' : 'open',
    assignee_id: params.get('assignee_id'),
    current_status_id: params.get('current_status_id'),
    due_mode: params.get('overdue') === 'true' ? 'overdue' : 'all',
    due_date: params.get('due_date'),
    final_outcome_id: params.get('final_outcome_id'),
    sort: params.get('sort') || defaultUrlFilters.sort,
    sort_direction: params.get('sort_direction') || defaultUrlFilters.sort_direction,
  };
};

export const pageFromSearch = (search) => {
  const params = new URLSearchParams(search);
  return {
    current: parseInt(params.get('page'), 10) || 1,
    pageSize: parseInt(params.get('per_page'), 10) || DEFAULT_PAGE_SIZE,
    total: 0,
  };
};

export const urlParamsFromState = (urlFilters, pagination) => cleanParams({
  lifecycle: urlFilters.lifecycle,
  assignee_id: urlFilters.assignee_id,
  current_status_id: urlFilters.current_status_id,
  due_date: urlFilters.due_date,
  overdue: urlFilters.due_mode === 'overdue' ? 'true' : null,
  final_outcome_id: urlFilters.final_outcome_id,
  sort: urlFilters.sort,
  sort_direction: urlFilters.sort_direction,
  page: pagination.current,
  per_page: pagination.pageSize,
});

export const apiParamsFromState = (urlFilters, searchTerm, pagination) => cleanParams({
  ...urlParamsFromState(urlFilters, pagination),
  search: searchTerm,
});
